import { Pipe, PipeTransform } from '@angular/core';
import spacetime, { ParsableDate, type Spacetime } from 'spacetime';

@Pipe({
	name: 'spaceMap',
})
export class SpaceMapPipe implements PipeTransform {
	transform(value: ParsableDate, timezone?: string): Spacetime {
		if (value == null) return null;

		const st = spacetime(value, timezone);
		if (st.epoch > 0) return st;
		else return null;
	}
}
